export const primary = process.env.__DEV__ || document.URL.startsWith(process.env.FRONT_BASE_URL);

export const toFQDN = (pathname: string) => {
  return `${process.env.FRONT_BASE_URL}${pathname}`;
};

export const domain = {
  primary,
  toFQDN,
};